import {  useState } from "react";
import UserHomeScreen from "./UserHomeScreen";
import UserCourseListScreen from "./UserCourseListScreen";
import UserCourseScreen from "./UserCourseScreen";
import StudentDashboard from "./StudentDashboard";

const UserScreen = () => {
    const [screen, setScreen] = useState('home');
    const [previousScreen, setPreviousScreen] = useState(null); 
    const [course, setCourse] = useState(null);

    const handleContextMenu = (e) => {
        e.preventDefault(); 
    };

    const navigate = (newScreen) => {
        setPreviousScreen(screen);
        setScreen(newScreen);
    };

    return (
        <div onContextMenu={handleContextMenu}>
            {screen === 'home' && (
                <UserHomeScreen
                    onCourseClick={(course) => {
                        console.log('HERE');

                        setCourse(course);
                        navigate('course');
                    }}
                    onCourseDetailClick={(course) => {
                        console.log('HERE1');
                        setCourse(course);
                        navigate('coursedetail');
                    }}
                />
            )}
            {screen === 'course' && (
                <UserCourseListScreen
                    course={course}
                    onBack={() => navigate('home')} 
                    onCourseDetailClick={(course) => {
                        setCourse(course);
                        navigate('coursedetail');
                    }}
                />
            )}
            {screen === 'coursedetail' && (
                <UserCourseScreen
                    course={course}
                    onBack={() => {
                        navigate(previousScreen === 'course' ? 'course' : 'home');
                    }}
                />
            )}
            {screen === 'grades' && (
                <StudentDashboard
                    onBack={() => navigate('home')} 

                />
            )}
        </div>
    );
};

export default UserScreen;
